import { Link } from "react-router-dom";
import SiteLayout from "@/components/feature/SiteLayout";
import Seo from "@/components/base/Seo";
import Breadcrumb from "@/components/base/Breadcrumb";
import { site } from "@/mocks/site";
import ContactForm from "@/pages/contact/components/ContactForm";

const crumbs = [
  { label: "首页", path: "/" },
  { label: "联系我们", path: "/contact" },
];

const channels = [
  {
    icon: "ri-mail-send-line",
    title: "投稿爆料",
    value: site.contactEmail,
    desc: "附上原帖链接与截图，材料越完整越容易被整理成时间线。",
    href: `mailto:${site.contactEmail}`,
  },
  {
    icon: "ri-customer-service-2-line",
    title: "内容纠错与下架",
    value: site.email,
    desc: "如内容存在事实性错误或涉及个人信息，请说明具体位置，我们会尽快核对。",
    href: `mailto:${site.email}`,
  },
  {
    icon: "ri-wechat-line",
    title: "公众号同步更新",
    value: "搜索「网红大瓜」",
    desc: "每日推送当日最热的三条大瓜摘要，适合通勤时快速浏览。",
    href: `mailto:${site.email}`,
  },
];

const notes = [
  "请尽量使用公开可查的链接，避免转发来源不明的私人材料。",
  "涉及具体人物的内容，建议同时提供另一方回应，避免单方定性。",
  "我们不会公开你的邮箱与联系方式，仅用于必要时的核实沟通。",
  "材料提交后不一定都会整理发布，编辑部会优先处理可核实的部分。",
];

export default function Contact() {
  return (
    <SiteLayout>
      <Seo
        title="联系我们 | 网红大瓜 - 瓜友投稿、爆料与内容纠错通道"
        description="有瓜想投，或需要内容纠错与下架？通过网红大瓜联系页面提交材料，附上原帖链接、截图与时间，编辑部会尽快核对并回复。"
        keywords={["网红大瓜", "网红大瓜投稿", "网红大瓜联系", "爆料投稿", "内容纠错"]}
        canonicalPath="/contact"
        breadcrumbs={crumbs}
        jsonLd={[
          {
            "@context": "https://schema.org",
            "@type": "ContactPage",
            name: "联系我们 - 网红大瓜",
            url: "https://chengshunjt.cn/contact",
            inLanguage: "zh-CN",
            description: "网红大瓜投稿爆料与内容纠错通道。",
          },
          {
            "@context": "https://schema.org",
            "@type": "Organization",
            name: site.name,
            url: "https://chengshunjt.cn/",
            email: site.email,
            contactPoint: {
              "@type": "ContactPoint",
              contactType: "customer support",
              email: site.contactEmail,
              availableLanguage: ["zh-CN"],
            },
          },
        ]}
      />

      <section className="border-b border-background-200 bg-foreground-950">
        <div className="mx-auto max-w-[1400px] px-4 py-14 md:px-6 md:py-20">
          <div className="mb-4 [&_a]:text-background-300 [&_span]:text-background-50 [&_ol]:text-background-400">
            <Breadcrumb items={crumbs} />
          </div>
          <span className="mb-3 inline-flex items-center gap-2 text-xs font-medium tracking-[0.25em] text-accent-400">
            <i className="ri-chat-forward-line" />
            CONTACT US
          </span>
          <h1 className="mb-4 max-w-3xl font-heading text-3xl font-black text-background-50 md:text-5xl">
            联系我们 · 把线索交给我们
          </h1>
          <p className="max-w-3xl text-sm leading-relaxed text-background-200 md:text-base">
            无论是投稿爆料、内容纠错，还是希望下架涉及个人信息的内容，都可以通过下面的表单或邮箱联系我们。
            编辑部通常在 1 至 2 个工作日内处理并回复。
          </p>
        </div>
      </section>

      <div className="mx-auto max-w-[1400px] px-4 py-12 md:px-6 md:py-16">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-12 lg:gap-12">
          <div className="lg:col-span-7">
            <ContactForm />
          </div>

          <aside className="lg:col-span-5">
            <div className="space-y-6">
              <div className="space-y-4">
                {channels.map((item) => (
                  <div
                    key={item.title}
                    className="rounded-lg border border-background-200 bg-background-100 p-5"
                  >
                    <div className="mb-3 flex items-center gap-3">
                      <span className="flex h-10 w-10 items-center justify-center rounded-md bg-primary-100 text-primary-600">
                        <i className={`${item.icon} text-lg`} />
                      </span>
                      <div>
                        <h2 className="font-heading text-base font-bold text-foreground-950">
                          {item.title}
                        </h2>
                        <a
                          href={item.href}
                          className="text-sm text-primary-600 transition-colors hover:text-primary-700"
                        >
                          {item.value}
                        </a>
                      </div>
                    </div>
                    <p className="text-sm leading-relaxed text-foreground-600">{item.desc}</p>
                  </div>
                ))}
              </div>

              <div className="rounded-lg border border-background-200 bg-background-50 p-6">
                <h2 className="mb-4 flex items-center gap-2 font-heading text-base font-bold text-foreground-950">
                  <i className="ri-file-list-2-line text-primary-500" />
                  投稿须知
                </h2>
                <ul className="space-y-3">
                  {notes.map((note) => (
                    <li key={note} className="flex items-start gap-3 text-sm leading-relaxed text-foreground-600">
                      <i className="ri-checkbox-circle-line mt-0.5 text-secondary-600" />
                      <span>{note}</span>
                    </li>
                  ))}
                </ul>
              </div>

              <div className="rounded-lg border border-accent-300 bg-accent-100 p-6">
                <h2 className="mb-2 flex items-center gap-2 font-heading text-base font-bold text-accent-950">
                  <i className="ri-question-line" />
                  想先了解我们的规则？
                </h2>
                <p className="mb-4 text-sm leading-relaxed text-accent-900">
                  关于内容来源、核查方式与处理原则，都写在关于我们页面，看一遍能省掉不少来回沟通。
                </p>
                <Link
                  to="/about"
                  className="inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-4 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 cursor-pointer"
                >
                  查看内容原则
                  <i className="ri-arrow-right-line" />
                </Link>
              </div>
            </div>
          </aside>
        </div>
      </div>
    </SiteLayout>
  );
}